export default __webpack_public_path__ + "static/media/seed-burning.daedebf6.png";